import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useOccurrencesStore = defineStore('occurrences', {
  state,
  getters,
  actions
})

export default useOccurrencesStore
